import {
  getGetPharosUserTosPharosUserTOSGetQueryKey,
  getListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGetQueryKey,
  updatePharosUserStatusRoutePharosUserStatusPut,
  updatePharosUserTrialRoutePharosUserTrialPut,
  useListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet,
  type TOSAgreementSchema,
  type UserTrialSchema,
} from "@phc/common/gen/preferencesGen"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useSnackbar } from "notistack"

/**
 * The API returns richer user trial data than the spec declares.
 * These types reflect the actual response shape until the backend spec is fixed.
 */
export interface PharosUserTrial {
  user?: {
    user_id?: string
    primary_email_address?: string
    deleted_at?: string | null
  }
  is_trial_user?: boolean
  trial_started_at?: string | null
  trial_ended_at?: string | null
  tos_agreement?: TOSAgreementSchema | null
}

export interface OrganizationUsersTrials {
  organization?: {
    organization_id?: string
    organization_name?: string
  }
  users_trials?: PharosUserTrial[]
}

interface ListAllTrialsResponse {
  organizations_users_trials?: OrganizationUsersTrials[]
}

export const useListAllTrials = () => {
  return useListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGet<ListAllTrialsResponse>()
}

export const useUpdateUserStatus = () => {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation({
    mutationFn: (variables: { userId?: string; isActive?: boolean }) =>
      updatePharosUserStatusRoutePharosUserStatusPut({
        user_id: variables.userId ?? "",
        is_active: variables.isActive ?? false,
      }),
    retry: 5,
    onError: (err: Error) => {
      enqueueSnackbar("Failed to update user status.", { variant: "error" })
      console.error(err)
    },
    onSuccess: () => {
      enqueueSnackbar("Updated user status", { variant: "success" })
      void queryClient.invalidateQueries({
        queryKey:
          getListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGetQueryKey(),
      })
    },
  })
}

export const useUpdateUserTrial = () => {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation({
    mutationFn: (variables: { userTrial: UserTrialSchema }) =>
      updatePharosUserTrialRoutePharosUserTrialPut({
        user_trial: variables.userTrial,
      }),
    retry: 5,
    onError: (err: Error) => {
      enqueueSnackbar("Failed to update user status.", { variant: "error" })
      console.error(err)
    },
    onSuccess: () => {
      enqueueSnackbar("Updated user status", { variant: "success" })
      void queryClient.invalidateQueries({
        queryKey:
          getListOrganizationsUsersTrialsRouteOrganizationsUsersTrialsGetQueryKey(),
      })
      void queryClient.invalidateQueries({
        queryKey: getGetPharosUserTosPharosUserTOSGetQueryKey(),
      })
    },
  })
}
